import UAParser from 'ua-parser-js'

const parser = new UAParser()
const result = parser.getResult()

export type DeviceType = 'desktop' | 'mobile' | 'tablet' | 'desktop' | 'other'

export function getDeviceType(): DeviceType {
  switch (result.device.type) {
    case 'mobile':
    case 'tablet': {
      return result.device.type
    }
    case 'smarttv':
    case 'wearable':
    case 'embedded':
    case 'console': {
      return 'other'
    }
    default: {
      return 'desktop'
    }
  }
}

type BrowserType = 'chrome' | 'edge' | 'firefox' | 'safari' | 'other' | 'unknown'

export function getBrowserType(): BrowserType {
  if (!result.browser.name) {
    return 'unknown'
  }

  switch (result.browser.name) {
    case 'Chrome': {
      return 'chrome'
    }
    case 'Edge': {
      return 'edge'
    }
    case 'Firefox': {
      return 'firefox'
    }
    case 'Mobile Safari':
    case 'Safari': {
      return 'safari'
    }
    default: {
      return 'other'
    }
  }
}

type OSType = 'android' | 'macos' | 'ios' | 'linux' | 'windows' | 'other' | 'unknown'

export function getOS(): OSType {
  if (!result.os.name) {
    return 'unknown'
  }

  switch (result.os.name) {
    case 'Android': {
      return 'android'
    }
    case 'Mac OS': {
      return 'macos'
    }
    case 'iOS': {
      return 'ios'
    }
    case 'Linux': {
      return 'linux'
    }
    case 'Windows': {
      return 'windows'
    }
    default: {
      return 'other'
    }
  }
}
